// Medications section form field enum
export enum MedicationsFormField {
  MEDICATIONS = 'medications',
  MEDICATION_SUMMARY = 'medications/medication-summary'
}
